import ErrorsView from "./ErrorsView";
import ProductionIssues from "./ProductionIssues";
import ShipmentGoals from "./ShipmentGoals";

const ReportPage = () => (
  <div className="p-6 flex flex-col gap-12">
    <ShipmentGoals />
    <ProductionIssues />
    <ErrorsView />
  </div>
);

export default ReportPage;
